/**
 * @Author: zachalam
 * @Date:   2017-03-15T13:45:38-07:00
 * @Email:  zach@reflexmedia.com
 * @Last modified by:   zachalam
 * @Last modified time: 2017-03-15T13:45:38-07:00
 */

import React, { ReactElement } from 'react';
import GDPRDelete from '../components/pages/Settings/GDPRDelete';

const GDPRDeleteContainer = (): ReactElement => {
  return <GDPRDelete />;
};

export default GDPRDeleteContainer;
